import React, {useEffect, useState} from 'react';
import { StyleSheet } from 'react-native';

interface UserDeactivatedPopupProps {
    onClose: () => void;
}


const UserDeactivatedPopup: React.FC<UserDeactivatedPopupProps> = ({ onClose }) => {
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
      });

    useEffect(() => {
        const handleResize = () => {
          setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
          });
        };
    
        window.addEventListener("resize", handleResize);
    
        return () => window.removeEventListener("resize", handleResize);
      }, []);


    const styles = StyleSheet.create({
        popup: {
            width: windowSize.width > 900 ? windowSize.width * 0.35 : windowSize.width * 0.9,
            backgroundColor: '#fff',
            position: 'absolute',
            zIndex: 1001,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
        },
    });

    return (
        <div style={styles.popup} className='popup-shadow ds-pop ds-pop--center'>
            <div className='d-flex px-3 pt-3 justify-content-between'>
                <h5>Your account was deactivated</h5>
            </div>
            <div className='px-3 mt-3 pb-3 d-flex flex-column'>
               <small>
                You have been looged out and your user deactivated.
               </small>
               <small>
                Please contact your manager.
               </small>
                <div className='d-flex mt-4 align-items-center justify-content-center' style={{ gap: '10px', flexWrap: 'nowrap' }}>
                    <button className='blue-outline-btn align-items-center d-flex w-100 px-5' onClick={onClose} style={{borderRadius: 8, maxWidth: 'fit-content'}}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};




export default UserDeactivatedPopup;

